import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

function UserLinkFormatter({ row, column }) {
  let username, userId;
  if (column.name === 'customer_username') {
    username = row.customer_username;
    userId = row.customer_user_id;
  } else if (column.name === 'tech_username') {
    username = row.tech_username;
    userId = row.tech_user_id;
  }
  if (!username || !userId) return <span>{username}</span>;
  return (
    <a
      href={`/service/user/details/${userId}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500 }}
    >
      {username}
    </a>
  );
}

const UserTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={UserLinkFormatter}
    {...props}
  />
);

export default UserTypeProvider;
